import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { SurfaceCard } from "@/components/common/Cards";
import { LogoPlaceholder } from "@/components/common/Logo";
import { Button } from "@/components/ui/button";
import { LayoutTemplate, FileText, Plus } from "lucide-react";
import { toast } from "sonner";

export default function Templates() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/templates").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div>
      <PageHeader title="Templates" subtitle="Report and document templates for your practice" breadcrumb={["Management", "Templates"]}
        actions={<Button onClick={() => toast.info("Custom templates coming soon")} className="bg-[#00A85A] hover:bg-[#008F4D] text-white rounded-lg"><Plus className="h-4 w-4 mr-1.5" />New Template</Button>} />
      <div className="mb-6"><LogoPlaceholder label="Clinic branding · Upload logo to appear on all reports" className="w-full max-w-md py-6" /></div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {(items || []).map((t) => (
          <SurfaceCard key={t.id} className="p-5 group cursor-pointer hover:border-[#00A85A]/40" onClick={() => toast.info(`${t.name} template selected`)}>
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#E8F7F0] dark:bg-[#00A85A]/15 mb-3"><FileText className="h-5 w-5 text-[#00A85A]" /></div>
            <div className="text-sm font-bold text-[#101516] dark:text-white">{t.name}</div>
            <div className="text-xs text-[#8B9698] mt-0.5">{t.description}</div>
            <div className="mt-3 text-[11px] font-semibold text-[#8B9698] border-t border-[#E2E8F0]/60 dark:border-[#223139]/60 pt-3">Used {t.usage} times</div>
          </SurfaceCard>
        ))}
      </div>
    </div>
  );
}
